import { render } from "./ChapterDetailsEditor.vue?vue&type=template&id=55fc5286"
import script from "./ChapterDetailsEditor.vue?vue&type=script&lang=js"
export * from "./ChapterDetailsEditor.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Callum\\Desktop\\k1890584_watkins_callum_code\\mo-books\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__